import {
    GET_PRODUCT_LIST_PROGRESS, GET_PRODUCT_LIST_SUCCESS, GET_PRODUCT_LIST_FAILURE,
    ADD_PRODUCT_PROGRESS, ADD_PRODUCT_SUCCESS, ADD_PRODUCT_FAILURE,
    EDIT_DELETE_PRODUCT_PROGRESS, EDIT_DELETE_PRODUCT_SUCCESS, EDIT_DELETE_PRODUCT_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    product: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const product_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_PRODUCT_LIST_SUCCESS:
            return { ...state, product: action.product, loading: false };
        case GET_PRODUCT_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_PRODUCT_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_PRODUCT_PROGRESS:
            return { ...state, loading: true };
        case ADD_PRODUCT_SUCCESS:
            return { ...state, product: [...state.product, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_PRODUCT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_PRODUCT_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_PRODUCT_SUCCESS:
            return {
                ...state,
                product: state.product.map((product) =>
                    product.id === action.payload.id ? action.payload : product
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_PRODUCT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default product_reducer;